<template>
  <div class="page-detail-main">
    <Spin v-if="pageLoading" fix style="z-index: 999999;" />
    <!--列表-->
    <div class="orderTable">
      <div class="mb5 row-between-flex">
        <div>
          <Button type="primary" v-if="permission.export" @click="exportHand" :disabled="exportLoading">导出</Button>
        </div>
        <div>
          <setTableColumn
            :moduleData="tableColumnData"
            buttonName="自定义仓库"
            :disabled="tableDataLoading"
            @updataColumn="updataTableColumn"
          />
        </div>
      </div>
      <Table
        highlight-row
        :loading="tableDataLoading"
        border
        :height="tableHeight"
        :columns="tableColumns"
        :data="tableData"
        @on-selection-change="choseTableDataChange"
        @on-sort-change="tableSortHand"
      />
      <!-- <div class="mt5" slot="page-top">
        <Checkbox v-model="allPageStatus">所有页全选</Checkbox>
      </div> -->
      <!-- 分页 -->
      <div class="table-page">
        <div class="table-page-right">
          <Page
            :total="tableTotal"
            @on-change="pageChangeHand"
            show-total
            :page-size="pageParams.pageSize"
            show-elevator
            :current="pageParams.pageNum"
            show-sizer
            @on-page-size-change="pageSizeChangeHand"
            placement="top"
            :page-size-opts="pageArray"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api/api';
import md5 from 'blueimp-md5';
import Mixin from '@/components/mixin/common_mixin';
import setTableColumn from '@/views/productCenter/components/productCenter/setTableColumn';
import productData from '@/views/productCenter/components/productCenter/staticData/productData';
// import productMixin from '@/components/mixin/product_mixin';
// import tableMixin from '@/components/mixin/table_mixin';

export default {
  mixins: [Mixin],
  components: {
    setTableColumn
  },
  props: {
    getSeatchFilter: { type: Function, default: () => {} }
  },
  data () {
    return {
      allPageStatus: false,
      tableDataLoading: false,
      exportLoading: false,
      pageLoading: false,
      allUserData: this.$store.state.userInfoList,
      productStatus: productData.productStatus,
      warehouseDataList: [],
      warehouseList: [],
      salesStatusObj: {},
      typeGroupObj: {},
      typeGroupList: [],
      tableHeadList: [],
      pageArray: [10, 20, 50, 100, 500],
      // 总记录数
      tableTotal: 0,
      // 映射列表筛选参数
      pageParams: {
        // orderBy: '',
        // upDown: 'down',
        pageNum: 1,
        pageSize: 50
      },
      tableColumnData: [
        {
          tabLabel: '自定义仓库列表显示',
          tabKey: 'warehouseDataList',
          required: true,
          // 替换的 key
          replaceKey: { label: 'warehouseName', value: 'warehouseId', isCheck: 'isCheck' },
          // 判断是否改变
          estimateChange: (newVal, oldVal) => {
            return JSON.stringify(newVal) != JSON.stringify(oldVal);
          },
          // 恢复默认设置
          renewData: () => {
            if (this.$common.isEmpty(this.warehouseDataList)) return [];
            let info = this.warehouseDataList.find(item => item.warehouseName == '佛山丽山仓');
            if (this.$common.isEmpty(info)) {
              info = this.warehouseDataList[0];
            }
            return [info.warehouseId];
          },
          // 对应数据
          options: [],
          // 更新选中的数据
          updateData: (data) => {
            this.warehouseDataList.forEach(item => {
              item.isCheck = data.includes(item.warehouseId);
            });
          }
        }
      ],
      // 选中的数据
      chosedTableRowData: [],
      // 列表数据
      tableData: [],
      // 列表列定义
      beforeColumn: [
        {
          title: 'SPU',
          key: 'spu',
          minWidth: 140,
          align: 'center',
          fixed: 'left',
          render: (h, { row }) => {
            return h('div', {
              style: {
                color: '#2d8cf0',
              }
            }, `${row.spu || ''}`);
          }
        },
        {
          title: 'SKU',
          key: 'sku',
          minWidth: 140,
          align: 'center',
          fixed: 'left',
        },
        {
          title: '商品状态',
          key: 'status',
          width: 90,
          align: 'center',
          fixed: 'left',
          render: (h, { row }) => {
            let text = '';
            this.productStatus.forEach(item => {
              if (item.value == row.status) {
                text = h('span', item.label)
              }
            })
            return text;
          }
        },
        {
          title: '规格',
          key: 'specification',
          width: 140,
          align: 'center',
          fixed: 'left',
          render: (h, { row }) => {
            if (this.$common.isEmpty(row.productGoodsSpecifications)) return h('div', {}, '');
            let pos = '';
            row.productGoodsSpecifications.forEach((n, i) => {
              if (i !== row.productGoodsSpecifications.length - 1) {
                pos += n.value + '·';
              } else {
                pos += n.value;
              }
            });
            return h('div', {}, pos);
          }
        },
      ],
      tableColumns: [],
    };
  },
  watch: {},
  created () {
    let awaitRes = [
      this.getWarehouse,
    ];
    this.pageLoading = true;
    this.$common.promiseAll(awaitRes).finally(() => {
      this.initHand().finally(() => {
        // this.setEmptyTextTop();
        this.pageLoading = false;
        // this.searchTableData();
      })
    });
  },
  computed: {
    tableHeight () {
      return this.getTableHeight(286);
    },
    // 可查看的事业部
    businessDeptIds() {
      if (!this.$store.getters['authUserInfo'] || !this.$store.getters['authUserInfo'].securityUser) return '';
      return this.$store.getters['authUserInfo'].securityUser.businessDeptIds;
    },
    // 权限
    permission () {
      return {
        // 导出
        export: this.getPermission('productGoods_exportInventory')
      }
    },
    userId () {
      if (!this.$store.getters['authUserInfo'] || !this.$store.getters['authUserInfo'].securityUser) return '';
      return this.$store.getters['authUserInfo'].securityUser.erpUserId || '';
    },
    cacheKey () {
      if (this.$common.isEmpty(this.userId)) return `${process.env.NODE_ENV}-defaultCacheTableColumnKey`;
      return `${process.env.NODE_ENV}-cacheTableColumnKey-${this.userId}`;
    },
  },
  methods: {
    // 初始化数据
    initHand () {
      return new Promise((resolve) => {
        this.salesStatusObj = {};
        this.typeGroupObj = {};
        this.typeGroupList = [md5('瑞服工厂')];
        this.tableColumns = this.$common.copy(this.beforeColumn);
        this.warehouseDataList.forEach(item => {
          if (item.isYms == 1) {
            if (this.$common.isUndefined(this.typeGroupObj['yms'])) {
              this.$set(this.typeGroupObj, 'yms', []);
            }
            this.typeGroupObj['yms'].push(item.warehouseName);
            if (!this.typeGroupList.includes('yms')) {
              this.typeGroupList.push('yms');
            }
          } else {
            if (this.$common.isUndefined(this.typeGroupObj[item.warehouseType])) {
              this.$set(this.typeGroupObj, item.warehouseType, []);
            }
            this.typeGroupObj[item.warehouseType].push(item.warehouseName);
            if (!this.typeGroupList.includes(item.warehouseType)) {
              this.typeGroupList.push(item.warehouseType);
            }
          }
        });
        this.tableColumnData.forEach(item => {
          let getStorageVal = window.localStorage.getItem(`${item.tabKey}-${this.cacheKey}`);
          getStorageVal = this.$common.isEmpty(getStorageVal) ? [] : JSON.parse(getStorageVal);
          this[item.tabKey].forEach(op => {
            op.isCheck = getStorageVal.includes(op[item.replaceKey.value]);
          });
          // 仓库处理
          if (item.tabKey == 'warehouseDataList') {
            let info = this[item.tabKey].find(f => f.isCheck);
            if (this.$common.isEmpty(info)) {
              this[item.tabKey].forEach(f => {
                if (f.warehouseName == '佛山丽山仓') {
                  f.isCheck = true;
                  getStorageVal = [f.warehouseId];
                  window.localStorage.setItem(`${item.tabKey}-${this.cacheKey}`, JSON.stringify(getStorageVal));
                }
              });
              info = this[item.tabKey].find(f => f.isCheck);
              if (this.$common.isEmpty(info)) {
                this[item.tabKey][0].isCheck = true;
                getStorageVal = [this[item.tabKey][0].warehouseId];
                window.localStorage.setItem(`${item.tabKey}-${this.cacheKey}`, JSON.stringify(getStorageVal));
              }
            }
          }
          item.options = this[item.tabKey];
        });

        this.$nextTick(() => {
          resolve({ state: 'finally' });
        })
      })
    },
    // 获取所有仓库
    getWarehouse() {
      return new Promise((resolve) => {
        this.warehouseList = [];
        const defaultItem = { warehouseName: '瑞服工厂', warehouseId: '瑞服工厂', isYms: null, warehouseType: md5('瑞服工厂') };
        this.axios.post(api.queryAllUserWarehouse, {}, { hiddenError: true }).then(res => {
          if (res && res.data && res.data.status === 200) {
            this.warehouseList = this.$common.isEmpty(res.data.data) ? [] : res.data.data;
            this.warehouseDataList = this.$common.copy(this.$common.isEmpty(res.data.data) ? [] : res.data.data);
            this.warehouseDataList.unshift(defaultItem);
            this.warehouseList.unshift({ warehouseName: '全部', warehouseId: -1 });
          }
        }).catch(() => {
          this.warehouseDataList = this.$common.copy([defaultItem]);
        }).finally(() => {
          resolve({ state: 'finally' });
        })
      });
    },
    // 搜索参数
    skuSearchParams () {
      let param = this.getSeatchFilter();
      const removeKey = [];
      let warehouseIdList = [];
      // param.statusList = param.skuStatusList;
      // param.productCodeList = this.$common.isEmpty(param.code) ? [] : param.code.split(',');
      param.businessDeptIdList = this.businessDeptIds.split(',');
      this.warehouseDataList.forEach(item => {
        if (item.isCheck) {
          warehouseIdList.push(item.warehouseId);
        }
      });
      param.warehouseIdList = warehouseIdList;
      removeKey.forEach(key => {
        delete param[key];
      });
      return { ...param, ...this.pageParams };
    },
    // 搜索列表数据
    searchTableData (type) {
      if (this.tableDataLoading) return;
      if (type) {
        this.pageParams.pageNum = 1;
      }
      this.tableDataLoading = true;
      this.chosedTableRowData = [];
      this.tableColumns = this.$common.copy(this.beforeColumn);
      this.$nextTick(() => {
        let searchFilter = this.skuSearchParams();
        this.axios.post(api.querySkuInventory, searchFilter).then((res) => {
          if (!res || !res.data || res.data.code != 0 || this.$common.isEmpty(res.data.datas) || this.$common.isEmpty(res.data.datas.list)) {
            this.tableData = [];
            this.tableTotal = 0;
            this.tableDataLoading = false;
            return;
          }
          // 处理仓库列
          this.tableColumns = [...this.tableColumns, ...this.handTableColumn(res.data.datas.list[0].inventoryMap || {})];
          // 处理列表数据
          let inventoryMap = {};
          let other = {};
          let newTableList = [];
          (res.data.datas.list || []).forEach(row => {
            inventoryMap = this.$common.copy(row.inventoryMap);
            Object.keys(inventoryMap).forEach(key => {
              Object.keys(inventoryMap[key]).forEach(cKey => {
                other[`${md5(key)}-${md5(cKey)}`] = inventoryMap[key][cKey];
              })
            });
            delete row.inventoryMap;
            newTableList.push({ ...row, ...other });
          });
          this.tableData = newTableList;
          this.tableTotal = res.data.datas.total || newTableList.length;
          this.$nextTick(() => {
            this.tableDataLoading = false;
            this.$emit('resizeTbale', {});
          })
        }).catch((err) => {
          console.error(err);
          this.tableData = [];
          this.tableTotal = 0;
          this.tableDataLoading = false;
        })
      })
    },
    // 分页切换
    pageChangeHand (page) {
      this.pageParams.pageNum = page;
      this.$nextTick(() => {
        this.searchTableData();
      })
    },
    // 页码改变
    pageSizeChangeHand (pageSize, plat) {
      this.pageParams.pageSize = pageSize;
      this.$nextTick(() => {
        this.searchTableData();
      })
    },
    // 选择行改变时
    choseTableDataChange (value) {
      this.chosedTableRowData = value;
    },
    // 表格列排序
    tableSortHand (data) {
      this.pageParams.orderBy = data.column.sortKey;
      this.pageParams.upDown = data.order == 'asc' ? 'up' : 'down';
      this.$nextTick(() => {
        this.searchTableData();
      })
    },
    // 更新列显示
    updataTableColumn (obj) {
      let info = {};
      let isRefreshTable = false;
      Object.keys(obj).forEach(key => {
        if (key != 'callBack') {
          if (obj[key].isChange) {
            isRefreshTable = true;
            info = this.tableColumnData.find(f => f.tabKey == key);
            if (!this.$common.isEmpty(info) && this.$common.isFunction(info.updateData)) {
              info.updateData(obj[key].data);
            }
            window.localStorage.setItem(`${key}-${this.cacheKey}`, JSON.stringify(obj[key].data));
          }
        }
      });
      this.$nextTick(() => {
        if (isRefreshTable) {
          this.searchTableData();
        }
        if (this.$common.isFunction(obj.callBack)) {
          obj.callBack();
        }
      });
    },
    // 处理仓库列方法
    handTableColumn (obj) {
      let first = '';
      let columnList = [];
      let child = [];
      let childCol = [];
      let second = '';
      Object.keys(obj).forEach(key => {
        first = md5(key);
        child = Object.keys(obj[key]);
        if (!this.$common.isEmpty(child)) {
          childCol = [];
          child.forEach(cKey => {
            second = md5(cKey);
            childCol.push({
              title: cKey,
              key: `${first}-${second}`,
              align: 'center',
              minWidth: 90,
            });
          });
          columnList.push({
            title: key,
            key: first,
            align: 'center',
            children: childCol
          });
        }
      });
      // let newColumn = [];
      // 仓库显示按类型分组
      // this.typeGroupList.forEach(type => {
      //   newColumn = [...newColumn, ...columnList.filter(col => this.typeGroupObj[type].includes(col.title))];
      // });
      // return newColumn;
      // 仓库名称和返回的仓库名称存在不一样，直接使用返回什么就展示什么仓库
      return columnList;
    },
    // 导出操作
    exportHand (str) {
      if (this.exportLoading) return;
      let searchFilter = this.skuSearchParams();
      searchFilter.productInventoryExport = true;
      this.exportLoading = true;
      this.axios.post(api.exportSkuInventory, searchFilter).then((res) => {
        if (res && res.data && res.data.code == 0 && res.data.datas) {
          this.$Message.success(`导出操作执行成功，稍后到“导出查看”页面中查看，导出任务号：${res.data.datas}`);
        }
      }).finally(() => {
        this.exportLoading = false;
      });
    },
  }
};
</script>
<style scoped lang="less">
.page-detail-main {
  .row-between-flex{
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  :deep(.ivu-table-cell) {
    .text-align-dom {
      display: inline-block;
      margin: 0 auto;
      text-align: left;
    }
    .table-td-class {
      .ivu-btn{
        margin-right: 5px;
        &:last-child{
          margin-right: 0;
        }
      }
    }
  }
}
.table-page{
  margin: 0;
  .table-page-right{
    float: initial;
    margin-bottom: 0;
    padding: 0;
    text-align: right;
    .ivu-page{
      display: inline-block;
    }
  }
}
</style>
